import React from 'react'

import { Link } from '@src/quince-components/src/atoms/link'
import QRCanvas from '@src/quince-components/src/atoms/qrCanvas/QRCanvas'
import { TRACK_PAGE_TYPE } from '@src/quince-site-common/src/domains/PageTypes'
import QuinceLogo from '@src/quince-site-common/src/organisms/appLayout/molecules/header/icons/quince-q-logo.svg'

import styles from './app-install-accounts.module.scss'
import { type AccountPlacement, useAppInstallAccountsPresenter } from './app-install.presenter'

interface AppInstallAccountsDesktopConfig {
  title: string
  qrAlt: string
}

interface AppInstallAccountsMobileConfig {
  title: string
  actionLabel: string
}

export interface AppInstallAccountsProps {
  trackPageType?: TRACK_PAGE_TYPE
  placement: AccountPlacement
  desktopConfig: AppInstallAccountsDesktopConfig
  mobileConfig: AppInstallAccountsMobileConfig
}

// Unlike `AppInstallFooter`/`AppInstallDs`, which render the presenter's
// Statsig-sourced copy, this variant takes all copy via `desktopConfig`/
// `mobileConfig` props (i18n); the presenter supplies only behavior/URLs.
export const AppInstallAccountsLegacy = ({
  trackPageType,
  placement,
  desktopConfig,
  mobileConfig,
}: AppInstallAccountsProps) => {
  const p = useAppInstallAccountsPresenter({ trackPageType, placement })

  if (!p.shouldRender) return null

  if (p.isMobile) {
    return (
      <section aria-label={mobileConfig.title} className={styles.appInstallAccountsWrapperMobile}>
        <QuinceLogo aria-hidden="true" width={48} height={48} className={styles.quinceLogo} />
        <div className={styles.appInstallAccountsTitleMobile}>{mobileConfig.title}</div>
        <Link href={p.mwebDeeplink} onClick={p.onCtaClick} className={styles.appInstallAccountsLinkMobile}>
          {mobileConfig.actionLabel}
        </Link>
      </section>
    )
  }

  return (
    <section aria-label={desktopConfig.title} className={styles.appInstallAccountsWrapper}>
      <div role="img" aria-label={desktopConfig.qrAlt}>
        <QRCanvas url={p.dwebDeeplink} widthInPx={62} margin={0} />
      </div>
      <div>{desktopConfig.title}</div>
    </section>
  )
}
